export const ROLE_ROUTES = {
  admin: "/admin/dashboard",
  user: "/workshop-owner",
};

export const DEFAULT_ROUTE = "/";

export function getRouteForUser(user) {
  if (!user?.groups?.length && !user?.role) return DEFAULT_ROUTE;
  if (user.groups.includes("admin") || user.role === "admin") return ROLE_ROUTES.admin;
  return `${ROLE_ROUTES.user}/${user.companyId}`;
}